export default "/auth/login/logo.png";